import React, { useState } from "react";
import { Redirect } from "react-router-dom";
import Header from "../../CoreComponents/Header";
import MainHeader from "../../CoreComponents/MainHeader";
import NavBar from "../../CoreComponents/NavBar";
import "./settlements.css";
import { canSettle } from "./access";
import { dateInIndia } from "./dates";
import SalaryEnrollment from "./SalaryEnrollment";
import SubmittedSalaries from "./SubmittedSalaries";

export default function RiderSettlement() {
  const [range, setRange] = useState(() => {
    const yesterday = dateInIndia(new Date(), -1);
    return { from: yesterday, to: yesterday };
  });
  const [enrolling, setEnrolling] = useState(false);

  if (!canSettle()) return <Redirect to="/orders" />;

  return (
    <div id="main-wrapper">
      <MainHeader />
      <Header name="Rider Salary" subHeading="Each rider's salary, for a day or any range of days" />
      <NavBar />
      <div className="content-body" style={{ minHeight: "100vh" }}>
        {enrolling ? (
          <SalaryEnrollment initialDate={range.to} onBack={() => setEnrolling(false)} />
        ) : (
          <SubmittedSalaries range={range} onRangeChange={setRange} onEnroll={() => setEnrolling(true)} />
        )}
      </div>
    </div>
  );
}
